import {type TabsProps} from 'antd'
import {z} from 'zod'

export type TabItem = NonNullable<TabsProps['items']>[number]

export enum Size {
  LARGE = 'large',
  MEDIUM = 'medium',
  SMALL = 'small',
}

export enum Width {
  FIXED = 'fixed',
  DYNAMIC = 'dynamic',
  FULL = 'full',
}

export enum Icon {
  NONE = 'none',
  GIFT = 'gift',
  HEART = 'heart',
  SECURE = 'secure',
}

export const genericPaylinkButtonConfigSchema = z.object({
  size: z.enum(Size),
  width: z.enum(Width),
  primary_color: z.string(),
  primary_color_raw: z.string().optional(),
  label: z.string(),
  icon: z.enum(Icon),
  border_radius: z.number().int(),
})

export type GenericPaylinkButtonConfig = z.infer<
  typeof genericPaylinkButtonConfigSchema
>

export const genericPaylinkButtonConfigSolutionSchema = z.record(
  z.string(),
  genericPaylinkButtonConfigSchema
)
export type GenericPaylinkButtonConfigSolution = z.infer<
  typeof genericPaylinkButtonConfigSolutionSchema
>
